export const getWairarapaData = () => ({
  name: "Wairarapa",
  country: "Nouvelle-Zélande",
  description: "Wairarapa est une région viticole de qualité située à l'extrémité sud de l'île du Nord, réputée pour ses vins de Pinot Noir élégants et ses vins blancs aromatiques. Cette région bénéficie d'un climat maritime avec des influences océaniques modérées.",
  type: "region",
  area: "1,200 ha",
  production: "0.1 million hectolitres",
  climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
  soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
  characteristics: {
    climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
    soil: "Sols alluviaux, graviers, argiles, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégant avec tanins fins, notes de fruits rouges et épices",
    white: "Vins blancs secs et aromatiques, avec une belle acidité",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Wairarapa a commencé dans les années 1980 avec les premiers vignobles commerciaux. Le Pinot Noir est rapidement devenu le cépage emblématique de la région, produisant des vins avec une personnalité unique grâce au climat maritime. Aujourd'hui, Wairarapa est reconnue pour ses vins de qualité et son approche artisanale.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, plats locaux, cuisine fusion",
  subregions: {
    "Martinborough": {
      name: "Martinborough",
      description: "Cœur viticole de Wairarapa, spécialisé dans le Pinot Noir",
      area: "600 ha",
      characteristics: "Sols calcaires, climat maritime, vins élégants",
      grapeVarieties: ["pinot-noir", "chardonnay", "sauvignon-blanc", "pinot-gris"]
    },
    "Gladstone": {
      name: "Gladstone",
      description: "Zone viticole produisant des vins rouges et blancs de qualité",
      area: "400 ha",
      characteristics: "Sols argileux, climat tempéré, vins équilibrés",
      grapeVarieties: ["pinot-noir", "chardonnay", "sauvignon-blanc", "syrah"]
    },
    "Masterton": {
      name: "Masterton",
      description: "Zone viticole traditionnelle avec des vignobles établis",
      area: "200 ha",
      characteristics: "Sols alluviaux, microclimats, vins aromatiques",
      grapeVarieties: ["sauvignon-blanc", "chardonnay", "pinot-noir", "riesling"]
    }
  },
  grapeVarieties: [
    {
      name: "Pinot Noir",
      percentage: "45%",
      description: "Cépage emblématique de Wairarapa, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "25%",
      description: "Cépage blanc principal, produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Chardonnay",
      percentage: "20%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Gris",
      percentage: "5%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant Syrah, Riesling et cépages expérimentaux",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Martinborough", x: 175.5, y: -41.0, color: "#4B164C", size: 4 },
    { region: "Gladstone", x: 175.6, y: -41.1, color: "#6d2c7a", size: 3 },
    { region: "Masterton", x: 175.7, y: -40.9, color: "#8a4a8a", size: 2 }
  ]
}); 